
// 文章下评论组件
import { mapState, mapGetters, mapMutations } from 'vuex';
import * as types from '~/types';
import initTime from '~/plugins/initTime.js';
import * as api from '~/api/index';
import { safeHtml } from '~/utils/safeHtml';
import MessageDialog from '~/components/public/violation/message-dialog.vue';
import { linkPage } from '~/utils/util';
import { formatCommit } from '~/utils/index.js';

export default {
  directives: {
    // 使用函数实现
    'g-html': (el, binding) => {
      el.innerHTML = safeHtml(binding.value);
    },
  },
  components: {
    MessageDialog,
  },
  data() {
    return {
      pageId: null,
      page: 1,
      count: 10,
      hasMoreInfo: true,
      commentInfo: {
        content: '',
      },
      commentsList: [],
      replyCommentInfo: {
        replyCommentId: null,
        content: '',
      },
      messageData: {
        show: false,
        content: '',
      },
      linkPage,
    };
  },
  computed: {
    ...mapGetters('user', ['isFollow', 'isLogin', 'userInfo']),
    ...mapState(['user']),
  },

  mounted() {
    this.pageId = this.$route.params.id;
    this.getCommentsList();
  },

  methods: {
    formatText(content) {
      return formatCommit(content);
    },
    closeDialog() {
      this.messageData.show = false;
    },
    getMoreInfo() {
      this.page++;
      this.getCommentsList();
    },
    async replyComment(items) {
      const res = await this.$axios(
        api.sendComment({
          source: 'article',
          refId: this.pageId,
          ...this.replyCommentInfo,
        })
      );
      if (res.statusCode === 200) {
        this.messageData.content = '已发布<br>内容审核中';
      } else if (res.statusCode === 417) {
        this.messageData.content = '当前内容审核中无法回复';
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
      this.page = 1;
      this.getCommentsList();
      this.cancelReplyComment(items);
    },
    async sendComment() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      const res = await this.$axios(
        api.sendComment({
          source: 'article',
          refId: this.pageId,
          content: this.commentInfo.content,
        })
      );
      if (res.statusCode === 200) {
        this.messageData.content = '已发布<br>内容审核中';
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
      this.page = 1;
      this.commentInfo.content = '';
      this.getCommentsList();
    },
    cancelReplyComment(data) {
      this.replyCommentInfo = {
        content: '',
        replyCommentId: null,
      };
    },
    initReplyComment(data) {
      this.replyCommentInfo = {
        content: '',
        replyCommentId: data.commentId,
      };
    },
    async deleteSelfComment(items) {
      await this.$axios(
        api.deleteSelfComment({
          commentId: items.commentId,
        })
      );
      this.getCommentsList();
    },
    async getCommentsList() {
      if (!this.pageId) return;
      const res = await this.$axios(
        api.getCommentsList({
          pageId: this.pageId,
          page: this.page,
          count: this.count,
        })
      );

      const totalCount = res.totalCount;
      this.hasMoreInfo = totalCount - this.page * this.count > 0 ? true : false;
      this.commentsList =
        this.page === 1 ? res.result : [...this.commentsList, ...res.result];
    },
    initTime(t) {
      return initTime(t);
    },
    ...mapMutations('user', [types.SHOW_LOGIN_FORM]),
  },
};
